
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16.176","height":"22.2"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 65995"}},[_c('g',{attrs:{"data-name":"Group 13"}},[_c('path',{attrs:{"data-name":"Path 13","d":"M15.917 17.938l-1.072-2.014v-4.975a6.768 6.768 0 00-4.881-6.491V1.975a1.875 1.875 0 10-3.749 0v2.483a6.768 6.768 0 00-4.881 6.491v4.974L.261 17.937a1.24 1.24 0 001.094 1.823h4.261a2.478 2.478 0 004.949 0h4.261a1.24 1.24 0 001.094-1.823zM7.205 1.975a.883.883 0 111.765 0v2.276a6.785 6.785 0 00-1.765 0zm-4.881 8.974a5.764 5.764 0 1111.528 0v4.564H2.323zm5.764 10.159a1.488 1.488 0 01-1.48-1.347h2.959a1.488 1.488 0 01-1.48 1.347zm6.948-2.459a.244.244 0 01-.213.12H1.352a.248.248 0 01-.219-.365l1.012-1.9h11.884l1.016 1.896a.244.244 0 01-.01.249z","fill":"#fff","stroke":"#fff","stroke-width":".2"}})])])])
          )
        }
      }
    